<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="commonFormStyles contractDetails">
            <van-nav-bar
                title="合同进度"
                left-text="合同列表"
                left-arrow
                @click-left="onClickLeft"
            >
            </van-nav-bar>
            <section>
                <van-collapse v-model="activeNames">
                    <van-collapse-item name="1">
                        <div slot="title" class="title">
                            <i class="iconfont icondingdan"></i>基本信息
                        </div>
                        <van-cell
                            :value="value"
                            title="合同编号"
                            :icon="require('@/assets/images/icons/icon_gy_1.png')"
                        ></van-cell>
                        <van-cell
                            :value="value"
                            title="工程名称"
                            :icon="require('@/assets/images/icons/icon_2.png')"
                        ></van-cell>
                        <van-cell
                            :value="value"
                            title="客户名称"
                            :icon="require('@/assets/images/icons/icon_3.png')"
                        ></van-cell>
                        <van-cell
                            :value="value"
                            title="预计方量"
                            :icon="require('@/assets/images/icons/icon_30.png')"
                        ></van-cell>
                        <van-cell
                            :value="value"
                            title="供货方量"
                            :icon="require('@/assets/images/icons/icon_30.png')"
                        ></van-cell>
                        <van-cell
                            :value="value"
                            title="剩余方量"
                            :icon="require('@/assets/images/icons/icon_30.png')"
                        ></van-cell>
                        <van-cell
                            :value="value"
                            title="结算次数"
                            :icon="require('@/assets/images/icons/icon_19.png')"
                        ></van-cell>
                        <van-cell
                            :value="value"
                            title="最近结算时间"
                            :icon="require('@/assets/images/icons/icon_gy_7.png')"
                        ></van-cell>
                        <van-cell
                            :value="value"
                            title="最近付款时间"
                            :icon="require('@/assets/images/icons/icon_gy_7.png')"
                        ></van-cell>
                        <van-cell
                            :value="value"
                            title="最近供应时间"
                            :icon="require('@/assets/images/icons/icon_gy_7.png')"
                        ></van-cell>
                        <van-cell
                            :value="value"
                            title="销售金额"
                            :icon="require('@/assets/images/icons/icon_26.png')"
                        ></van-cell>
                        <van-cell
                            :value="value"
                            title="结算金额"
                            :icon="require('@/assets/images/icons/icon_26.png')"
                        ></van-cell>
                        <van-cell
                            :value="value"
                            title="回款金额"
                            :icon="require('@/assets/images/icons/icon_26.png')"
                        ></van-cell>
                        <van-cell
                            :value="value"
                            title="回款率"
                            :icon="require('@/assets/images/icons/icon_38.png')"
                        ></van-cell>
                        <van-cell
                            :value="value"
                            title="逾期欠款"
                            :icon="require('@/assets/images/icons/icon_26.png')"
                        ></van-cell>
                        <van-cell
                            :value="value"
                            title="尾款金额"
                            :icon="require('@/assets/images/icons/icon_26.png')"
                        ></van-cell>
                        <van-cell
                            :value="value"
                            title="累计欠款"
                            :icon="require('@/assets/images/icons/icon_26.png')"
                        ></van-cell>
                        <van-cell
                            :value="value"
                            title="施工进度"
                            :icon="require('@/assets/images/icons/my_9.png')"
                        ></van-cell>
                    </van-collapse-item>
                    <van-collapse-item name="2">
                        <div slot="title" class="title">
                            <i class="iconfont iconlianxiren"></i>统计信息
                        </div>
                        <ul>
                            <li>
                                <h4>当月产值统计</h4>
                                <div class="chart">
                                    <van-circle
                                        class="van_left"
                                        v-model="currentRate"
                                        :rate="20"
                                        :size="90"
                                        :speed="100"
                                        color="#3495FB"
                                        layer-color="#d5e9fe"
                                        :stroke-width="100"
                                    ></van-circle>
                                    <div class="outputValue">
                                        <h5>40%</h5>
                                        <p>产值结算率</p>
                                    </div>
                                    <div class="van_left legend">
                                        <p class="productionValue">
                                            当月生产值：
                                            <span>¥100000.00</span>
                                        </p>
                                        <p class="settlementOutputValue">
                                            当月结算产值：
                                            <span>¥40000.00</span>
                                        </p>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </van-collapse-item>
                </van-collapse>
            </section>
        </div>
    </v-touch>
</template>
<script>
export default {
    // 合同进度详情
    name: 'contract-details',
    components: {},
    props: {},
    data() {
        return {
            activeNames: ['1', '2'],
            value: 'aa',
            currentRate: 0,
        };
    },
    computed: {},
    watch: {},
    created() {},
    mounted() {},
    destroyed() {},
    methods: {
        // 返回上一页
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
        // 右划回退
        swiperright() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
    },
};
</script>
<style lang="stylus">
.contractDetails
    height 100%
    section
        ul
            padding 15rpx
            background #F0F0F0
            li
                margin-bottom 15rpx
                background #ffffff
                border-radius 4rpx
                padding 15rpx
                &:last-child
                    margin-bottom 0
                h4
                    font-size 16rpx
                    color #333333
                    margin-bottom 15rpx
                .chart
                    overflow hidden
                    position relative
                    .van-circle
                        margin-right 30rpx
                    .outputValue
                        position absolute
                        width 85rpx
                        height 85rpx
                        text-align center
                        padding-top 20rpx
                        h5
                            font-size 16rpx
                            margin-bottom 5rpx
                            color #3495FB
                        p
                            font-size 10rpx
                            color #3495FB
                    .legend
                        color #979EA7
                        font-size 12rpx
                        p
                            margin 12rpx 0
                        span
                            font-size 16rpx
                        .productionValue
                            span
                                color #3495FB
                        .settlementOutputValue
                            span
                                color #F55244
    .van-icon
        .van-icon__image
            width 16rpx
            height 16rpx
            margin-top 3rpx
            margin-right 5rpx
    .van-collapse
        &:after
            display none
    .van-cell__title
        width 100rpx
        font-size 18rpx
        line-height 24rpx
        color #061F3E
        .iconfont
            font-size 18rpx
            margin-right 5rpx
    .van-collapse-item__content
        .van-cell__title
            font-size 16rpx
    .title
        font-size 17rpx
        color #3495FB
    .van-collapse-item__content
        padding 0
    .van-field__control,
    .van-cell__value
        color #979EA7
        &::placeholder
            color #D7D7D7 !important
</style>